import React from 'react'

export const IconDeliveryTruck = ({ fill = '#010C77' }: { fill?: string }) => (
    <svg
        width="44"
        height="40"
        viewBox="0 0 44 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="44" height="40" rx="20" fill={fill} />
        <path
            d="M23 24V14C23 13.4477 22.5523 13 22 13H14C13.4477 13 13 13.4477 13 14V24C13 24.5523 13.4477 25 14 25H15M23 24C23 24.5523 22.5523 25 22 25H19M23 24L23 16C23 15.4477 23.4477 15 24 15H26.5858C26.851 15 27.1054 15.1054 27.2929 15.2929L30.7071 18.7071C30.8946 18.8946 31 19.149 31 19.4142V24C31 24.5523 30.5523 25 30 25H29M23 24C23 24.5523 23.4477 25 24 25H25M15 25C15 26.1046 15.8954 27 17 27C18.1046 27 19 26.1046 19 25M15 25C15 23.8954 15.8954 23 17 23C18.1046 23 19 23.8954 19 25M25 25C25 26.1046 25.8954 27 27 27C28.1046 27 29 26.1046 29 25M25 25C25 23.8954 25.8954 23 27 23C28.1046 23 29 23.8954 29 25"
            stroke="white"
            strokeWidth="2"
        />
    </svg>
)
